import React from "react";
import CheckboxList from "./CheckboxList";

interface UserCheckboxListProps {
  title: string;
  readonly?: boolean;
  canBeEmpty?: boolean;
  availableUsers: server.dto.UserSmall[];
  selectedUserIds: number[];
  onChanged: (selectedTemplateIds: number[]) => void;
  onSave?: () => void;
}

export const UserCheckboxList = (props: UserCheckboxListProps) => {
  return (
    <CheckboxList
      canBeEmpty={props.canBeEmpty}
      readonly={props.readonly}
      options={props.availableUsers}
      getId={(user) => user.userId}
      getTitle={(user) => user.fullName}
      selectedIds={props.selectedUserIds}
      onChange={props.onChanged}
      checkboxLabel={RESX.SoUser.Access}
      header={<>{props.title}</>}
      validatorKey="users"
    />
  );
}